import { Button, Image } from 'antd-mobile'

import { useState } from 'react'
import { cn } from '@/utils'

interface PropsIn {
  data: unknown
  className?: string
  openChat?: () => void
  handleJoin?: () => Promise<void>
}

const GroupItem = (props: PropsIn) => {
  const { data, className, openChat, handleJoin } = props

  const [joinLoading, setJoinLoading] = useState(false)

  return (
    <div
      className={cn(
        'relative flex h-[390px] w-[299px] flex-col justify-between rounded-[15px] bg-color-white-trans10 px-[22px] pb-[22px] pt-[19px]',
        className,
      )}
      key={(data as Record<string, string>).group_id || (data as Record<string, string>).group_code}
    >
      <div>
        <div className='absolute left-1/2 top-[19px] h-[201px] w-[201px] -translate-x-1/2'>
          <span className='absolute left-1/2 top-1/2 h-[201px] w-[201px] -translate-x-1/2 -translate-y-1/2 rounded-full border border-solid border-white/5'></span>
          <span className='absolute left-1/2 top-1/2 h-[164px] w-[164px] -translate-x-1/2 -translate-y-1/2 rounded-full border border-solid border-color-white-trans10'></span>
          <span className='absolute left-1/2 top-1/2 h-[138px] w-[138px] -translate-x-1/2 -translate-y-1/2 rounded-full border border-solid border-white/30'></span>
          <Image
            className='absolute left-1/2 top-1/2 h-[104px] w-[104px] -translate-x-1/2 -translate-y-1/2 rounded-full'
            src={(data as Record<string, { avatar: string }>).group_info?.avatar || (data as Record<string, string>).avatar}
          />
        </div>

        <div className='absolute left-1/2 top-[228px] line-clamp-2 w-[254px] -translate-x-1/2 break-words text-center font-geologica text-[30px] leading-[38px] text-white'>
          {(data as Record<string, { name: string }>).group_info?.name || (data as Record<string, string>)?.name}
        </div>
      </div>

      <div className='mt-[22px] flex items-center justify-between'>
        <span className='font-geologica text-[22px] text-white/40'>{(data as Record<string, { num: number }>).group_info?.num}</span>
        {(data as Record<string, boolean>).in_group ? (
          <Button
            className={cn(
              'g-btn-v2 g-btn-v2-primary h-[45px] w-[86px] rounded-[7px] p-0 font-geologica text-[22px] leading-[45px] text-button-text-color',
            )}
            onClick={() => {
              openChat && openChat()
            }}
          >
            Open
          </Button>
        ) : (
          <Button
            className={cn('g-btn-v2 h-[45px] w-[86px] rounded-[7px] p-0 font-geologica text-[22px] leading-[45px] text-button-text-color')}
            loading={joinLoading}
            onClick={async () => {
              if (handleJoin && typeof handleJoin === 'function') {
                setJoinLoading(true)
                try {
                  await handleJoin()
                } finally {
                  setJoinLoading(false)
                }
              }
            }}
          >
            Join
          </Button>
        )}
      </div>
    </div>
  )
}

export default GroupItem
